import React from "react";
import Text from "./Text";

const Password = (props) => {
  return <Text password {...props} />;
};

export default Password;
